import * as yup from "yup";

const addTagValidation = yup.object().shape({
  name: yup.string().required("Name is required")
});

export default addTagValidation;
